export default __webpack_public_path__ + "static/HowriceshapedtheAmericanSouth-4464ef5038c9941841e01ab2da62ff14.jpg";